import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';
import { UsersAdminComponent } from './admin/users-admin.component';
import { USER_ROLE } from '../common/user';
import { AdminLayoutComponent } from '../layouts/admin/admin-layout.component';
import { BillingAdminComponent } from '../layouts/billing-admin/billing-admin.component';

export namespace AuthGuard {
    export const canActivate = (
        route: ActivatedRouteSnapshot, 
        state: RouterStateSnapshot
    ) => {
        const authService = inject(UserService);
        const router = inject(Router);

        const result = authService.isLoggedIn()

        const user = authService.getUser()
        if (!result || !user || user.role === USER_ROLE.GUEST) {
            router.navigateByUrl("/auth")
            return false
        }

        if (route.component === UsersAdminComponent || route.component === AdminLayoutComponent || route.component === BillingAdminComponent) return user.role === USER_ROLE.ADMIN

        return true
    }

    export const canActivateChild = (
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) => canActivate(route, state);
}
